<h2 class="first_title">Gestione Pagamenti</h2>
<div export-help></div>
<ul class="pathbar amministrazione">
  <li><a [routerLink]="[urlCancelleria]">Cancelleria telematica</a></li>
  <li>Gestione Pagamenti</li>
</ul>
<div class="content-page-wrapper">
  <div class="standardpanel">
    <div class="titleblock">
      <h3 class="title1levelNoMargin">Gestione Pagamenti</h3>
      <p>
        <a href="javascript:void(0)" (click)="onGeneraAvviso()">
          Genera Avviso <span class="glyphicon glyphicon-plus"></span>
        </a>
      </p>
    </div>

    <app-pagamenti-search
    (searchEvent)="getListaPagamenti($event)"
    ></app-pagamenti-search>

    <app-pagamenti-list
      [payments]="payments"
      [hasSearched]="hasSearched"
      (downloadAvvisoEvent)="downloadAvviso($event)"
      (downloadRicevutaEvent)="downloadRicevuta($event)"
      (refreshEvent)="onRefresh($event)"
    ></app-pagamenti-list>

  </div>
</div>
